import { Link } from 'react-router-dom';
import { StageTag } from '../../ui/index.js';

const stages = [
  ['New', 'NewRequest'],
  ['Discussion', 'InDiscussion'],
  ['Upcoming', 'Scheduled'],
  ['Editing', 'Editing'],
] as const;
export function DashboardWorkSummary({
  counts,
  demo = false,
}: {
  counts: readonly number[];
  demo?: boolean;
}) {
  return (
    <section className="crm-dashboard__panel crm-dashboard__work-summary" aria-label="Current work">
      <h2>Current work</h2>
      <div className="crm-dashboard__work-counts">
        {stages.map(([label, status], index) => (
          <Link key={status} to={demo ? '#dashboard' : `/crm/shoots?status=${status}`}>
            <StageTag status={status} dot>
              <span>{label}</span>
              <strong>{counts[index] ?? 0}</strong>
            </StageTag>
          </Link>
        ))}
      </div>
    </section>
  );
}
